import { dehydrate, QueryClient } from "@tanstack/react-query";
import { useTranslation } from "next-i18next";

import { PageLayout } from "@/components/layouts";
import SelectByLocale from "@/components/SelectByLocale";
import SubcategoriesGrid from "@/components/SubcategoriesGrid";
import { SubcategoriesPage } from "@/components/SubcategoriesPage";
import { getSiteSettings } from "@/services/sanity";
import { I18nextLanguage } from "@/types/types";
import { getAllTranslationsServerSide } from "@/utils/i18n";

export default function ShopPage() {
  const { t } = useTranslation();

  return (
    <PageLayout
      title={t("shop_meta_title")}
      description={t("shop_meta_description")}
      headerTheme="dark"
    >
      <SubcategoriesPage
        title={t("our_products")}
        blurb={t("our_products_blurb")}
      >
        <SubcategoriesGrid>
          <SelectByLocale visibleIfLanguage={I18nextLanguage.NO}>
            <SubcategoriesGrid.Card
              as="li"
              imgSrc="/assets/product-images/soap.jpg"
              slug="/nettbutikk/bestill-handsape-refill"
              title="Såpe"
            />
            <SubcategoriesGrid.Card
              as="li"
              imgSrc="/assets/product-images/cleaning.jpeg"
              slug="/nettbutikk/bestill-rengjoringsmidler-refill"
              title="Rengjøring"
            />
            <SubcategoriesGrid.Card
              as="li"
              imgSrc="/assets/product-images/laundry.jpeg"
              slug="/nettbutikk/bestill-vaskemiddel-refill"
              title="Vaskemiddel"
            />
          </SelectByLocale>
          <SelectByLocale visibleIfLanguage={I18nextLanguage.EN}>
            <SubcategoriesGrid.Card
              as="li"
              imgSrc="/assets/product-images/soap.jpg"
              slug="/nettbutikk/bestill-handsape-refill"
              title="Soap"
            />
            <SubcategoriesGrid.Card
              as="li"
              imgSrc="/assets/product-images/cleaning.jpeg"
              slug="/nettbutikk/bestill-rengjoringsmidler-refill"
              title="Cleaning"
            />
            <SubcategoriesGrid.Card
              as="li"
              imgSrc="/assets/product-images/laundry.jpeg"
              slug="/nettbutikk/bestill-vaskemiddel-refill"
              title="Laundry detergent"
            />
          </SelectByLocale>
        </SubcategoriesGrid>
      </SubcategoriesPage>
    </PageLayout>
  );
}

export async function getStaticProps({ locale }) {
  const queryClient = new QueryClient();
  const siteSettings = await getSiteSettings();

  return {
    props: {
      ...(await getAllTranslationsServerSide(locale)),
      dehydratedState: dehydrate(queryClient),
      siteSettings,
    },
  };
}
